import { createSlice } from '@reduxjs/toolkit';
import {
  API_VENUE_SUBMISSIONS_STATS,
  API_VENUE_SUBMISSIONS_LIST,
  API_VENUE_SUBMISSION_DETAIL,
  API_VENUE_SUBMISSION_VERIFY,
  API_VENUE_SUBMISSION_REJECT,
  API_VENUE_SUBMISSION_MERGE_WORKSPACE,
  API_VENUE_SUBMISSION_MERGE,
} from '../constants/index';

/** Build a query-string from a params object, skipping blank/null values. */
function buildQS(params) {
  const q = new URLSearchParams();
  Object.entries(params).forEach(([k, v]) => {
    if (v !== undefined && v !== null && v !== '') q.set(k, v);
  });
  const s = q.toString();
  return s ? `?${s}` : '';
}

// ─── Action creators ────────────────────────────────────────────────────────
// Each returns a plain object intercepted by reduxApiMiddleware.
// The middleware returns Promise.resolve(res.data) so callers can use .then()

export const getVenueSubmissionStats = () => ({
  type: 'API',
  payload: {
    url: API_VENUE_SUBMISSIONS_STATS,
    method: 'GET',
    hideLoader: true,
  },
});

export const getVenueSubmissionList = (params = {}) => ({
  type: 'API',
  payload: {
    url: `${API_VENUE_SUBMISSIONS_LIST}${buildQS(params)}`,
    method: 'GET',
    hideLoader: false,
  },
});

export const getVenueSubmissionDetail = (id) => ({
  type: 'API',
  payload: {
    url: API_VENUE_SUBMISSION_DETAIL(id),
    method: 'GET',
    hideLoader: true,
  },
});

export const verifyVenueSubmission = (id, body = {}) => ({
  type: 'API',
  payload: {
    url: API_VENUE_SUBMISSION_VERIFY(id),
    method: 'POST',
    data: body,
    hideLoader: false,
  },
});

export const rejectVenueSubmission = (id, body = {}) => ({
  type: 'API',
  payload: {
    url: API_VENUE_SUBMISSION_REJECT(id),
    method: 'POST',
    data: body,
    hideLoader: false,
  },
});

export const getMergeWorkspace = (id, masterVenueId) => ({
  type: 'API',
  payload: {
    url: `${API_VENUE_SUBMISSION_MERGE_WORKSPACE(id)}${masterVenueId ? `?master_venue_id=${masterVenueId}` : ''}`,
    method: 'GET',
    hideLoader: false,
  },
});

export const mergeVenueSubmission = (id, body) => ({
  type: 'API',
  payload: {
    url: API_VENUE_SUBMISSION_MERGE(id),
    method: 'POST',
    data: body,
    hideLoader: false,
  },
});

// ─── Slice (components manage their own state via .then()) ──────────────────
const UserSubmissionsSlice = createSlice({
  name: 'venueSubmissions',
  initialState: {},
  reducers: {},
});

export default UserSubmissionsSlice.reducer;
